import React, { useEffect } from "react";
import Button from "../../components/shared/button/Button";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../routing/routes";
import { Link } from "react-router-dom";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {}

const NotFoundView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[NotFoundView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[NotFoundView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="container">
        <div className="page-content">
          <div className="text-center">
            <h1>{t("pages.notFound.introTitle")}</h1>
            <p>{t("pages.notFound.description")}</p>
            <img src="/assets/images/undraw/not_found.svg" className="img-responsive mw-600 mt-5" />
            <Link className="btn btn-link mt-5" to={ROUTES.HOME}>
              {t("pages.notFound.backToHome")}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default NotFoundView;
